import { useCallback, useEffect, useState } from 'react';
import {
  produtosApi,
  type AtualizarProdutoRequest,
  type ProdutoResumo,
} from '@/features/produtos/api/produtosApi';
import { useSyncReload } from '@/shared/hooks/useSyncReload';

type Estado = {
  produtos: ProdutoResumo[];
  carregando: boolean;
  erro: string | null;
};

export function useProdutos() {
  const [estado, setEstado] = useState<Estado>({
    produtos: [],
    carregando: false,
    erro: null,
  });

  const recarregar = useCallback(() => {
    setEstado((s) => ({ ...s, carregando: true, erro: null }));
    return produtosApi.listar().then(
      (produtos) => setEstado({ produtos, carregando: false, erro: null }),
      (e: unknown) => {
        const mensagem = e instanceof Error ? e.message : 'Erro desconhecido';
        setEstado((s) => ({ ...s, carregando: false, erro: mensagem }));
      },
    );
  }, []);

  const atualizar = useCallback(
    async (id: string, dados: AtualizarProdutoRequest) => {
      await produtosApi.atualizar(id, dados);
      void recarregar();
    },
    [recarregar],
  );

  const excluir = useCallback(
    async (id: string) => {
      setEstado((s) => ({
        ...s,
        produtos: s.produtos.filter((p) => p.id !== id),
      }));
      try {
        await produtosApi.excluir(id);
      } finally {
        void recarregar();
      }
    },
    [recarregar],
  );

  useEffect(() => {
    void recarregar();
  }, [recarregar]);

  useSyncReload(recarregar);

  return { ...estado, recarregar, atualizar, excluir };
}
